export enum UserRole {
    ADMIN = 'admin',
    SUPER_ADMIN = 'super_admin'
}
